import React from 'react';
import { BsX } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Checkbox, HStack, Icon, IconButton } from '@chakra-ui/react';

import { fieldInputTypes } from '../../../../../../../../../../../../../../../constants/fieldInputTypes';
import colors from '../../../../../../../../../../../../../../../styles/theme/foundation/colors';
import { removeArrayItemAtIndex } from '../../../../../../../../../../../../../../../utils/arrayUtil';
import FormInput from '../../../../../../../../../../../../../../form/FormInput';
import { inputTypes } from '../../../../../../../../../../../../../../form/FormInput/util';

function CheckboxInputRow({ idx, options, useFormMethods, blueprint }) {
  const dispatch = useDispatch();
  const { register, setValue, getValues } = useFormMethods;

  return (
    <HStack
      alignItems="center"
      flexFlow="row noWrap"
      height="40px"
      key={idx}
      mb="20px"
      mt={idx > 0 ? '20px' : 0}
    >
      <Checkbox
        defaultChecked
        color={colors.primaryScale['600']}
        fontSize="md"
        fontWeight="medium"
        {...register(`${options.dataType}.${idx}.isChecked`)}
        isDisabled={options.isDisabled}
        isReadOnly={options?.isReadOnly}
      />
      <FormInput
        inputName={`${options.dataType}.${idx}.label`}
        placeholder={`Option ${Number(idx) + 1}`}
        size="sm"
        textStyle="bodyMd"
        type={inputTypes.checkBoxLabelInput}
        useFormMethods={useFormMethods}
        validationRules={{
          required: {
            value: true,
            message: 'Label is a required field'
          },
          maxLength: {
            value: 64,
            message: 'Label must have fewer than 64 characters'
          }
        }}
        width="100%"
      />
      <IconButton
        aria-label="Delete Policy Property"
        icon={<Icon as={BsX} boxSize="34px" />}
        variant="textGrey"
        onClick={() => {
          const currentFormValues = getValues();

          if (currentFormValues?.[options.dataType]?.length > 0) {
            const updatedValues = removeArrayItemAtIndex(currentFormValues[options.dataType], idx);

            setValue(options.dataType, updatedValues);
          }

          dispatch(blueprint.deleteCurrentPropertyInputOption(fieldInputTypes.Checkboxes, idx));
        }}
      />
    </HStack>
  );
}

export default CheckboxInputRow;
